import React, { createContext, useContext, useReducer } from 'react';
import { v4 as uuidv4 } from 'uuid';

import {
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  UPDATE_NOTIFICATION,
} from './types';

const NotificationContext = createContext();

const notificationReducer = (state, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };
    case REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: [
          ...state.notifications.filter(
            notification => notification.id !== action.payload
          ),
        ],
      };
    case UPDATE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.map(notification =>
          notification.id === action.payload.id ? action.payload : notification
        ),
      };
    default:
      return state;
  }
};

const NotificationProvider = ({ children }) => {
  const initialState = {
    notifications: [],
  };

  const [state, dispatch] = useReducer(notificationReducer, initialState);

  const addNotification = (message, type) => {
    const id = uuidv4();

    dispatch({ type: ADD_NOTIFICATION, payload: { id, message, type } });

    return id;
  };

  const removeNotification = id =>
    dispatch({ type: REMOVE_NOTIFICATION, payload: id });

  const removeNotificationWithDelay = (id, delay = 5000) => {
    setTimeout(() => removeNotification(id), delay);
  };

  const updateNotification = (id, message, type) =>
    dispatch({ type: UPDATE_NOTIFICATION, payload: { id, message, type } });

  return (
    <NotificationContext.Provider
      value={{
        notifications: state.notifications,
        addNotification,
        removeNotification,
        removeNotificationWithDelay,
        updateNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

const useNotification = () => useContext(NotificationContext);

export { NotificationProvider, useNotification };
